
export default {
    name: 'SvgFlashlight',
    props: {
        color: {
            type: String,
            default: '#FFF',
        },
    },
};
